import React, { useContext, useState, useEffect } from 'react';

import NavBarContainer from '../../components/navbar/NavBarContainer'
import User from '../../components/user/User'
import PlayerContainer from '../../components/player/PlayerContainer';
import ModalContainer from '../../widgets/modal/ModalContainer'

const PlayerContext = React.createContext()

export function GetPlayer(){
    return useContext(PlayerContext)
}



const Layout = ({children}) => {
    
    const [pid, setPid] = useState(null)
    const [tracks, setTracks] = useState(null)
    const [ modal, setModal ] = useState(null)
    const [ alert, setAlert ] = useState([])
    const values = {
        pid,
        setPid,
        setTracks,
        setModal
    }

    const spaceFunc = (event) => {
      if(event.keyCode === 27) {
        setModal(null)
        }
    }

    useEffect(() => {
      //fetch the new playlists here
      setAlert([...alert])
      document.addEventListener("keydown", spaceFunc, false);
    }, [modal])

    function playNext(){
      if(!tracks || !tracks.find(id => id === pid)){ setTracks(null) ; return false}
      if(tracks[tracks.length -1] === pid) return false; // check if item is last on playlist
      const i = tracks.indexOf(pid)
      if((i+1) < tracks.length) setPid(tracks[i+1])
      return true;
    }
    function playPrev(){
      if(!tracks ||  !tracks.find(id => id === pid)){ setTracks(null); return false}
      const i = tracks.indexOf(pid)
      if((i-1) >= 0) setPid(tracks[i-1])
      return true
    }
    return (
      <PlayerContext.Provider value={values}>
        <div className="layout">
            <NavBarContainer alert={alert} />
            {children}
            <User />
            <PlayerContainer playNext={playNext} playPrev={playPrev}/>
            <ModalContainer component={modal} />
        </div>
      </PlayerContext.Provider>
    );
};

export default Layout;